"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetGoVipPointMultiplierResponseAllOfToJSON = exports.GetGoVipPointMultiplierResponseAllOfFromJSONTyped = exports.GetGoVipPointMultiplierResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetGoVipPointMultiplierResponseAllOfFromJSON(json) {
    return GetGoVipPointMultiplierResponseAllOfFromJSONTyped(json, false);
}
exports.GetGoVipPointMultiplierResponseAllOfFromJSON = GetGoVipPointMultiplierResponseAllOfFromJSON;
function GetGoVipPointMultiplierResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'goVipPointMultipliers': (json['goVipPointMultipliers'].map(_1.GoVipPointMultiplierFromJSON)),
    };
}
exports.GetGoVipPointMultiplierResponseAllOfFromJSONTyped = GetGoVipPointMultiplierResponseAllOfFromJSONTyped;
function GetGoVipPointMultiplierResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'goVipPointMultipliers': (value.goVipPointMultipliers.map(_1.GoVipPointMultiplierToJSON)),
    };
}
exports.GetGoVipPointMultiplierResponseAllOfToJSON = GetGoVipPointMultiplierResponseAllOfToJSON;
